module.exports = __webpack_public_path__ + "d9bfa081015fa73bf7e0f4ae1c3b4052.svg";